var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info_filled"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5571_247589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5571_247589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M12 17C12.2833 17 12.5292 16.8958 12.7375 16.6875C12.9458 16.4792 13.05 16.2333 13.05 15.95V12.025C13.05 11.7417 12.9458 11.5 12.7375 11.3C12.5292 11.1 12.2833 11 12 11C11.7167 11 11.4708 11.1042 11.2625 11.3125C11.0542 11.5208 10.95 11.7667 10.95 12.05V15.975C10.95 16.2583 11.0542 16.5 11.2625 16.7C11.4708 16.9 11.7167 17 12 17ZM12 8.975C12.2833 8.975 12.5292 8.87083 12.7375 8.6625C12.9458 8.45417 13.05 8.20833 13.05 7.925C13.05 7.64167 12.9458 7.39583 12.7375 7.1875C12.5292 6.97917 12.2833 6.875 12 6.875C11.7167 6.875 11.4708 6.97917 11.2625 7.1875C11.0542 7.39583 10.95 7.64167 10.95 7.925C10.95 8.20833 11.0542 8.45417 11.2625 8.6625C11.4708 8.87083 11.7167 8.975 12 8.975ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
    fill: "#1F6CF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info_filled.45be983b2251ed3a03d3ede66d52094a.svg";
export { ForwardRef as ReactComponent };